import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  FormGroup,
  FormField,
  Input,
  Label,
  Dropdown,
  Icon,
  Checkbox
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardSettingPackageUX = (props: any) => {
    return(
      <div
        id="CardSettingPackageUX-div-0"
        style={{width: "100%"}}>
        <div
          id="CardSettingPackageUX-div-1"
          style={{display: props.hideTitle?"none":"flex", alignItems: "center", justifyContent: "space-between", padding: "15px 10px", backgroundColor: props.showPackageCategory?"white":"#A5D9FF"}}>
          
          <div
            id="CardSettingPackageUX-div-2"
            style={{fontSize: "1.15rem", fontWeight: "bold"}}>
            {props.showPackageCategory?"ตั้งค่าสำหรับเปิดขาย Package":"การตั้งค่ารายละเอียดแพ็กเกจ"}
          </div>
        </div>
        <div
          className="ui divider"
          id="CardSettingPackageUX-div-3"
          style={{marginTop: 0}}>
          
        </div>
        <div
          id="CardSettingPackageUX-div-4">
          {props.SubSearchPackage}
        </div>
        <div
          className={`ui form ${props.isActive  ? "--override-disabled": ""}`}
          id="CardSettingPackageUX-div-5"
          style={{ display: !props.hideDetail ? "": "none"}}>
          
          <FormGroup
            id="CardSettingPackageUX-FormGroup-164"
            style={{ padding: "0 20px" }}>
            <FormField
              id="CardSettingPackageUX-FormField-165"
              style={{fontWeight: "bold", fontSize: "1.2rem", borderBottom: "1px solid rgba(34,36,38,.15)", padding: "0px 0px 0.55rem 0.5rem"}}
              width={16}>
              <div
                id="CardSettingPackageUX-div-166">
                {props.packageDetail?.id?`${props.packageDetail?.code} : ${props.packageDetail?.name}`:props.showPackageCategory?"สร้างรายการ Paclage ใหม่":"เพิ่มรายการใหม่"}
              </div>
            </FormField>
          </FormGroup>
          <div
            id="CardSettingPackageUX-div-439"
            style={{ marginBottom: "1.5em", ...( !props.showPackageDisplay && { display: "none" } ) }}>
            {props.TabPackage}
          </div>
          <div
            id="CardSettingPackageUX-div-237"
            style={{ padding: "0 40px", ...( props.activePackage !== 0 && { display: "none" } )  }}>
            
            <FormGroup
              id="CardSettingPackageUX-FormGroup-6"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-7"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-13"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-14"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Code" : "รหัส"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-15">
                    {props.languageUX === "en" ? "Package code" : "รหัสแพ็กเกจ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-168"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.code ? "error" : ""}
                id="CardSettingPackageUX-FormField-8"
                inline={true}
                width={4}>
                <Input
                  disabled={props.isActive || false}
                  id="CardSettingPackage-Input-Code"
                  name="code"
                  onChange={props.onChangeValue}
                  value={props.packageDetail?.code || ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-184"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-185">
                <Label
                  color={props.labelActive?.color}
                  id="CardSettingPackageUX-Label-186"
                  style={{display: props.labelActive?.text?"":"none", width: "100px", textAlign: "center"}}>
                  {props.labelActive?.text}
                </Label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-16"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-17"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-20"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  {}
                  <label
                    id="CardSettingPackageUX-label-21"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Package name" : "ชื่อแพ็คเกจ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-22">
                    {props.languageUX === "en" ? "Package name" : "ชื่อแพ็กเกจ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-169"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.name ? "error" : ""}
                id="CardSettingPackageUX-FormField-18"
                inline={true}
                width={6}>
                <Input
                  disabled={props.isActive || false}
                  id="CardSettingPackage-Input-PackageName"
                  name="name"
                  onChange={props.onChangeValue}
                  value={props.packageDetail?.name|| ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-202"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-203"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-205"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-206"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Package name" : "ชื่อแพ็คเกจ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-207">
                    (EN)
                  </label>
                  <label
                    id="CardSettingPackageUX-label-208"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.name ? "error" : ""}
                id="CardSettingPackageUX-FormField-204"
                inline={true}
                width={6}>
                <Input
                  disabled={props.isActive || false}
                  id="CardSettingPackageUX-Input-209"
                  name="name_en"
                  onChange={props.onChangeValue}
                  value={props.packageDetail?.name_en|| ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-23">
              <FormField
                id="CardSettingPackageUX-FormField-26"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-29"
                  style={{display: "flex", alignItems: "center", width: "230px", marginTop: "0.75rem"}}>
                  {}
                  <label
                    id="CardSettingPackageUX-label-32"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Package type" : "ประเภทแพ็คเกจ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-33">
                    {props.languageUX === "en" ? "Package Type" : "ชนิดแพ็กเกจ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-170"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.package_type ? "error" : ""}
                id="CardSettingPackageUX-FormField-37"
                inline={true}
                width={4}>
                <div
                  id="CardSettingPackageUX-div-38"
                  style={{display: "flex",  alignItems: "baseline",}}>
                  
                  <Dropdown
                    clearable={true}
                    disabled={props.isActive || false}
                    id="CardSettingPackage-Dropdown-PackageType"
                    name="package_type"
                    onChange={props.onChangeValue}
                    options={props.packageTypeOptions || []}
                    search={true}
                    selection={true}
                    style={{width: "100%"}}
                    value={props.packageDetail?.package_type || ""}>
                  </Dropdown>
                  <div
                    id="CardSettingPackageUX-div-40"
                    style={{width: "fit-content", display: "flex", margin: "auto -7rem auto 1rem",cursor: "pointer", pointerEvents: props.isActive? "none": ""}}>
                    
                    <Icon
                      className="teal"
                      id="CardSettingPackageUX-Icon-41"
                      link={true}
                      name="plus"
                      onClick={()=> props.onOpenAdmin?.("PACKAGE_TYPE")}>
                    </Icon>
                    <div
                      id="CardSettingPackageUX-div-134"
                      style={{marginLeft: "0.75rem"}}>
                      {props.PackageRefreshIcon}
                    </div>
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-25"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-28"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-31"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-36"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Gender:" : "เพศ:"}
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.gender ? "error" : ""}
                id="CardSettingPackageUX-FormField-49"
                inline={true}
                width={2}>
                <Dropdown
                  disabled={props.isActive || false}
                  fluid={true}
                  id="CardSettingPackage-Dropdown-Gender"
                  name="gender"
                  onChange={props.onChangeValue}
                  options={props.genderOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.packageDetail?.gender || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-233"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-235"
                  style={{display: "flex", alignItems: "center"}}>
                  
                  <Checkbox
                    checked={props.packageDetail?.require_age_verification}
                    id="CardSettingPackageUX-Checkbox-236"
                    label="Require Age Verification"
                    name="require_age_verification"
                    onChange={props.onChangeValue}>
                  </Checkbox>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-24"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-27"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-30"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-34"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-35">
                    {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-171"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.package_service_type ? "error" : ""}
                id="CardSettingPackageUX-FormField-42"
                inline={true}
                style={{paddingRight: "0.75em"}}
                width={4}>
                <div
                  id="CardSettingPackageUX-div-43"
                  style={{display: "flex",  alignItems: "baseline",width: "100%"}}>
                  
                  <Dropdown
                    clearable={true}
                    disabled={props.isActive || false}
                    id="CardSettingPackage-Dropdown-ServiceType"
                    name="package_service_type"
                    onChange={props.onChangeValue}
                    options={props.serviceTypeOptions || []}
                    search={true}
                    selection={true}
                    style={{width: "100%"}}
                    value={props.packageDetail?.package_service_type || ""}>
                  </Dropdown>
                  <div
                    id="CardSettingPackageUX-div-47"
                    style={{width: "fit-content", display: "flex", margin: "auto -7rem auto 1rem",cursor: "pointer", pointerEvents: props.isActive? "none": ""}}>
                    
                    <Icon
                      className="teal"
                      id="CardSettingPackageUX-Icon-48"
                      link={true}
                      name="plus"
                      onClick={()=> props.onOpenAdmin?.("SERVICE_TYPE")}>
                    </Icon>
                    <div
                      id="CardSettingPackageUX-div-136"
                      style={{marginLeft: "0.75rem"}}>
                      {props.ServiceRefreshIcon}
                    </div>
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-51"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-52"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-54"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-55"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Age start" : "อายุเริ่มต้น"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-56">
                    {props.languageUX === "en" ? "Age (years)" : "อายุ (ปี)"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-172"
                    style={{color: "red"}}>
                    
                  </label>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-53"
                inline={true}
                width={2}>
                <Input
                  disabled={props.isActive || false}
                  fluid={true}
                  id="CardSettingPackage-Input-AgeStart"
                  name="age_limits_year_start"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                  style={{width: "100%"}}
                  type="number"
                  value={props.packageDetail?.age_limits_year_start ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-58"
                inline={true}
                width={2}>
                <div
                  id="CardSettingPackageUX-div-60"
                  style={{display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-61"
                    style={{fontWeight: "bold", marginRight: "5px"}}>
                    {props.languageUX === "en" ? "Age end" : "สิ้นสุดอายุ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-62">
                    {props.languageUX === "en" ? "Age (years)" : "อายุ (ปี)"}
                  </label>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-59"
                inline={true}
                width={2}>
                <Input
                  disabled={props.isActive || false}
                  fluid={true}
                  id="CardSettingPackage-Input-AgeEnd"
                  name="age_limits_year_end"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                  style={{width: "100%"}}
                  type="number"
                  value={props.packageDetail?.age_limits_year_end ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-137"
                style={{display: props.showAgeError ? "": "none"}}>
                <label
                  id="CardSettingPackageUX-label-138"
                  style={{color: "red", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Age end must not be less than Age start" : "Age end ต้องไม่น้อยกว่า Age start"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-64"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-65"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-69"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-71"
                    style={{fontWeight: "bold",}}>
                    {props.languageUX === "en" ? "Start date" : "วันที่เริ่มต้น"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-173"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.start_date? "error" : ""}
                id="CardSettingPackageUX-FormField-66"
                inline={true}
                width={2}>
                <div
                  id="CardSettingPackageUX-div-72"
                  style={{width: "100%"}}>
                  {props.StartDate}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-73"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-74"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-76"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-77"
                    style={{fontWeight: "bold"}}>
                    {props.languageUX === "en" ? "End date" : "วันที่สิ้นสุด"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-174"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.end_date? "error" : ""}
                id="CardSettingPackageUX-FormField-75"
                inline={true}
                width={2}>
                <div
                  id="CardSettingPackageUX-div-78"
                  style={{width: "100%"}}>
                  {props.EndDate}
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-79"
                inline={true}
                width={4}>
                <div
                  id="CardSettingPackageUX-div-80"
                  style={{display: "none", alignItems: "center", width: "100%", justifyContent: "flex-end"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-81"
                    style={{fontWeight: "bold", marginRight: "1rem"}}>
                    {props.languageUX === "en" ? "IsActive" : "ใช้งานอยู่"}
                  </label>
                  <Checkbox
                    checked={!!props.packageDetail?.active}
                    disabled={true}
                    id="CardSettingPackageUX-Checkbox-82"
                    name="active"
                    readOnly={true}
                    style={{transform: "scale(1.2)"}}>
                  </Checkbox>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-83"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-84"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-86"
                  style={{display: "grid", alignItems: "center", width: "230px"}}>
                  
                  <div
                    id="CardSettingPackageUX-div-175"
                    style={{display: "flex", marginRight: "5px"}}>
                    
                    <label
                      id="CardSettingPackageUX-label-176"
                      style={{fontWeight: "bold",}}>
                      {props.languageUX === "en" ? "Package pricing" : "ราคาแพ็คเกจ"}
                    </label>
                    <label
                      id="CardSettingPackageUX-label-177"
                      style={{color: "red"}}>
                      
                    </label>
                  </div>
                  <div
                    id="CardSettingPackageUX-div-181">
                    
                    <label
                      id="CardSettingPackageUX-label-182">
                      {props.languageUX === "en" ? "Selling price of this product" : "ราคาขายของสินค้านี้"}
                    </label>
                    <label
                      id="CardSettingPackageUX-label-183"
                      style={{color: "red"}}>
                      *
                    </label>
                  </div>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.price_normal? "error" : ""}
                id="CardSettingPackageUX-FormField-85"
                inline={true}
                width={2}>
                <Input
                  disabled={props.isActive || false}
                  fluid={true}
                  id="CardSettingPackage-Input-Price-Normal"
                  name="price_normal"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                  ref={props.inputRef}
                  style={{width: "100%"}}
                  type={props.isActive?"":"number"}
                  value={props.packageDetail?.price_normal|| ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-90">
                <label
                  id="CardSettingPackageUX-label-91">
                  {props.languageUX === "en" ? "baht" : "บาท"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-139"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-141"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-153"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-155"
                    style={{fontWeight: "bold"}}>
                    {props.languageUX === "en" ? "Package pricing (Premium)" : "ราคาแพ็กเกจ (พรีเมียม)"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-178"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.price_normal? "error" : ""}
                id="CardSettingPackageUX-FormField-142"
                inline={true}
                width={2}>
                <Input
                  disabled={props.isActive || false}
                  fluid={true}
                  id="CardSettingPackage-Input-Price-Premium"
                  name="price_premium"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                  ref={props.inputRef}
                  style={{width: "100%"}}
                  type={props.isActive?"":"number"}
                  value={props.packageDetail?.price_premium|| ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-146"
                inline={true}>
                <label
                  id="CardSettingPackageUX-label-151">
                  {props.languageUX === "en" ? "baht" : "บาท"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-140"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-143"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-154"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-156"
                    style={{fontWeight: "bold"}}>
                    {props.languageUX === "en" ? "Package pricing (Foreign)" : "ราคาแพ็กเกจ (ต่างประเทศ)"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-179"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.price_foreign? "error" : ""}
                id="CardSettingPackageUX-FormField-144"
                inline={true}
                width={2}>
                <Input
                  disabled={props.isActive || false}
                  fluid={true}
                  id="CardSettingPackage-Input-Price-Foreign"
                  name="price_foreign"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                  ref={props.inputRef}
                  style={{width: "100%"}}
                  type={props.isActive?"":"number"}
                  value={props.packageDetail?.price_foreign|| ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-145"
                inline={true}>
                <label
                  id="CardSettingPackageUX-label-152">
                  {props.languageUX === "en" ? "baht" : "บาท"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-157"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-158"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-161"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-163"
                    style={{fontWeight: "bold"}}>
                    {props.languageUX === "en" ? "Package type" : "ประเภทแพ็คเกจ"}
                  </label>
                  <label
                    id="CardSettingPackageUX-label-180"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.usage_limit? "error" : ""}
                id="CardSettingPackageUX-FormField-159"
                inline={true}
                width={2}>
                <Dropdown
                  clearable={true}
                  disabled={props.isActive || false}
                  fluid={true}
                  id="CardSettingPackage-Dropdown-UsageLimit"
                  name="usage_limit"
                  onChange={props.onChangeValue}
                  options={props.usageLimitOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.packageDetail?.usage_limit || ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-190"
              inline={true}
              style={{display: props.showPackageCategory?"":"none"}}>
              <FormField
                id="CardSettingPackageUX-FormField-191"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-193"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-195"
                    style={{fontWeight: "bold"}}>
                    Lab Category
                  </label>
                  <label
                    id="CardSettingPackageUX-label-196"
                    style={{color: "red"}}>
                    *
                  </label>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-192"
                inline={true}
                width={8}>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardSettingPackageUX-Dropdown-194"
                  multiple={true}
                  name="package_categories"
                  onChange={props.onChangeValue}
                  options={props.packageCategoryOptions ?? []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.packageDetail?.package_categories || []}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-190"
              inline={true}
              style={{display: props.showPackageCategory?"":"none"}}>
              <FormField
                id="CardSettingPackageUX-FormField-191"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-193"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-195"
                    style={{fontWeight: "bold"}}>
                    อาการ/ความกังวล (Health concerns)
                  </label>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-192"
                inline={true}
                width={8}>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardSettingPackageUX-Dropdown-194"
                  multiple={true}
                  name="health_concerns"
                  onChange={props.onChangeValue}
                  options={props.healthConcernListOptions ?? []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.packageDetail?.health_concerns || []}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-210"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-211"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-218"
                  style={{display: "grid", alignItems: "center", width: "230px"}}>
                  
                  <div
                    id="CardSettingPackageUX-div-219"
                    style={{display: "flex", marginRight: "5px"}}>
                    
                    <label
                      id="CardSettingPackageUX-label-222"
                      style={{fontWeight: "bold",}}>
                      อายุของแพ็กเกจ
                    </label>
                    <label
                      id="CardSettingPackageUX-label-223"
                      style={{color: "red"}}>
                      *
                    </label>
                  </div>
                  <div
                    id="CardSettingPackageUX-div-220">
                    
                    <label
                      id="CardSettingPackageUX-label-221">
                      อายุของแพ็กเกจนับตั้งแต่วันที่ซื้อขาย
                    </label>
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-212"
                inline={true}
                width={2}>
                <div
                  id="CardSettingPackageUX-div-224"
                  style={{ width: "100%" }}>
                  
                  <Input
                    fluid={true}
                    id="CardSettingPackageUX-Input-230"
                    name="lifespan_year"
                    onChange={props.onChangeValue}
                    onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                    style={{width: "100%"}}
                    type="number"
                    value={props.packageDetail?.lifespan_year|| ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-213"
                inline={true}>
                <label
                  id="CardSettingPackageUX-label-227">
                  ปี
                </label>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-214"
                inline={true}
                width={2}>
                <div
                  id="CardSettingPackageUX-div-225"
                  style={{ width: "100%" }}>
                  
                  <Input
                    fluid={true}
                    id="CardSettingPackageUX-Input-231"
                    name="lifespan_month"
                    onChange={props.onChangeValue}
                    onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                    style={{width: "100%"}}
                    type="number"
                    value={props.packageDetail?.lifespan_month|| ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-215"
                inline={true}>
                <label
                  id="CardSettingPackageUX-label-228">
                  เดือน
                </label>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-216"
                inline={true}
                width={2}>
                <div
                  id="CardSettingPackageUX-div-226"
                  style={{ width: "100%" }}>
                  
                  <Input
                    fluid={true}
                    id="CardSettingPackageUX-Input-232"
                    name="lifespan_day"
                    onChange={props.onChangeValue}
                    onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                    style={{width: "100%"}}
                    type="number"
                    value={props.packageDetail?.lifespan_day|| ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardSettingPackageUX-FormField-217"
                inline={true}>
                <label
                  id="CardSettingPackageUX-label-229">
                  วัน
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-157"
              inline={true}>
              <FormField
                id="CardSettingPackageUX-FormField-158"
                inline={true}>
                <div
                  id="CardSettingPackageUX-div-161"
                  style={{display: "flex", alignItems: "center", width: "230px"}}>
                  
                  <label
                    id="CardSettingPackageUX-label-163"
                    style={{fontWeight: "bold"}}>
                    ซื้อได้เฉพาะผ่าน Link Affiliage
                  </label>
                </div>
              </FormField>
              <FormField
                className={!!props.showRequiredField?.usage_limit? "error" : ""}
                id="CardSettingPackageUX-FormField-159"
                inline={true}
                width={2}>
                <Checkbox
                  checked={props.packageDetail?.is_affiliate_exclusive}
                  id="CardSettingPackageUX-Checkbox-454"
                  name="is_affiliate_exclusive"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-197"
              inline={true}
              style={{display: props.showPackageCategory?"":"none"}}>
              <FormField
                id="CardSettingPackageUX-FormField-199"
                inline={true}>
                <label
                  id="CardSettingPackageUX-label-200">
                  ข้อมูลเพิ่มเติมในการเตรียมตัวตรวจ Package
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSettingPackageUX-FormGroup-198"
              inline={true}
              style={{display: props.showPackageCategory?"":"none"}}>
              <FormField
                id="CardSettingPackageUX-FormField-201"
                inline={true}
                width={16}>
                {props.SunEditor}
              </FormField>
            </FormGroup>
            <div
              id="CardSettingPackageUX-div-92"
              style={{display: !props.hideDetail ?props.isNewProduct ? "none": "flex" : "none" , justifyContent: "flex-end", margin: "2rem 20px 1rem"}}>
              
              <Button
                disabled={props.disabledAddNewProduct || false}
                id="CardSettingPackageUX-Button-93"
                onClick={props.onAddNewProduct}
                style={{backgroundColor: "#5CD6F2", color: "white", display: "none"}}>
                <div
                  id="CardSettingPackageUX-div-94"
                  style={{display: "flex", alignItems: "center"}}>
                  
                  <Icon
                    id="CardSettingPackageUX-Icon-95"
                    name="plus">
                  </Icon>
                  <label
                    id="CardSettingPackageUX-label-97">
                    {props.languageUX === "en" ? "Add new item" : "เพิ่ม รายการใหม่"}
                  </label>
                </div>
              </Button>
            </div>
            <div
              className="ui form"
              id="CardSettingPackageUX-div-108"
              style={{display: !props.hideDetail ? props.isNewProduct ? "": "none":"none"}}>
              
              <FormGroup
                id="CardSettingPackageUX-FormGroup-109"
                inline={true}>
                <FormField
                  id="CardSettingPackageUX-FormField-111">
                  <label
                    id="CardSettingPackageUX-label-112"
                    style={{color: "red"}}>
                    {`ค้นหารายการสินค้าจาก ${props.tabName}`}
                  </label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardSettingPackageUX-FormGroup-110"
                inline={true}
                style={{display: "none"}}>
                <FormField
                  id="CardSettingPackageUX-FormField-113"
                  inline={true}>
                  <label
                    id="CardSettingPackageUX-label-118"
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Product Code" : "รหัสสินค้า"}
                  </label>
                </FormField>
                <FormField
                  id="CardSettingPackageUX-FormField-116"
                  inline={true}
                  width={7}>
                  <div
                    id="CardSettingPackageUX-div-121"
                    style={{width: "100%"}}>
                    {props.SearchBoxPCode}
                  </div>
                </FormField>
                <FormField
                  id="CardSettingPackageUX-FormField-115"
                  inline={true}>
                  <label
                    id="CardSettingPackageUX-label-119"
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Product Name" : "ชื่อสินค้า"}
                  </label>
                </FormField>
                <FormField
                  id="CardSettingPackageUX-FormField-114"
                  inline={true}
                  width={7}>
                  <div
                    id="CardSettingPackageUX-div-120"
                    style={{width: "100%"}}>
                    {props.SearchBoxPName}
                  </div>
                </FormField>
                <FormField
                  id="CardSettingPackageUX-FormField-117"
                  inline={true}>
                  <Button
                    color="green"
                    id="CardSettingPackageUX-Button-122"
                    onClick={props.onAddSuccess}
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "finish" : "เสร็จสิ้น"}
                  </Button>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardSettingPackageUX-FormGroup-187"
                inline={true}>
                <FormField
                  id="CardSettingPackageUX-FormField-188"
                  style={{padding:0, marginTop: "-0.25rem"}}
                  width={16}>
                  <div
                    id="CardSettingPackageUX-div-189"
                    style={{width: "100%"}}>
                    {props.CardProductSearch}
                  </div>
                </FormField>
              </FormGroup>
            </div>
            <div
              className="ui form"
              id="CardSettingPackageUX-div-99"
              style={{ display: !props.hideDetail ? "":"none"}}>
              {props.TabPans}
            </div>
            <div
              className="ui form"
              id="CardSettingPackageUX-div-98"
              style={{ display: !props.hideDetail ? "":"none"}}>
              {}
              <Table
                data={props.productItems || []}
                getTrProps={props.getTrProps}
                headers={props.productTableConfig?.headers ?? "ID,การส่งตรวจ,Product code,ชื่อสินค้า (EN),ชื่อสินค้า (TH),QTY,หน่วยสั่ง,Price,Display,Delete"}
                id="CardSettingPackageUX-Table-100"
                keys={props.productTableConfig?.keys ?? "product, lab_type, product_code, product_name_en,product_name,quantity,unit_name,price, is_display,delete"}
                minRows={5}
                showPagination={false}
                style={{height: "275px", marginTop: "1rem"}}
                widths={props.productTableConfig?.widths ?? "120,^70,^90,^150,^150,^70,^70,^80,^50,^50"}>
              </Table>
            </div>
            <div
              id="CardSettingPackageUX-div-124"
              style={{ borderRadius: "5px", padding: "8px 0rem 8px 15px", margin: "0 0px 0", display: !props.hideDetail ? props.showPriceTotalProduct? "flex":"none":"none", justifyContent: "space-between", width: "100%"}}>
              
              <div
                id="CardSettingPackageUX-div-125"
                style={{fontWeight: "bold", color: "#0072BC"}}>
                {`ราคาของ ${props.productType || ""} ทั้งหมด (บาท)`}
              </div>
              <div
                id="CardSettingPackageUX-div-129"
                style={{width: "150px", display: "flex", justifyContent: "center"}}>
                
                <div
                  id="CardSettingPackageUX-div-131"
                  style={{color: "#5A5A5A"}}>
                  {props.priceTotalProduct || ""}
                </div>
              </div>
            </div>
            <div
              id="CardSettingPackageUX-div-441"
              style={{background: "#FFF5F7", borderRadius: "5px", padding: "8px 0rem 8px 15px", margin: "0 0px 0", display: !props.hideDetail && props.freeGiftCount > 0 ? "flex":"none", justifyContent: "space-between", width: "100%"}}>
              
              <div
                id="CardSettingPackageUX-div-442"
                style={{fontWeight: "bold", color: "#D6305A"}}>
                {props.freeGiftLabel || ""}
              </div>
              <div
                id="CardSettingPackageUX-div-443"
                style={{width: "150px", display: "flex", justifyContent: "center"}}>
                
                <div
                  id="CardSettingPackageUX-div-444"
                  style={{color: "#DB2828", textDecoration: "line-through"}}>
                  {props.freeGiftTotal || ""}
                </div>
              </div>
            </div>
            <div
              id="CardSettingPackageUX-div-101"
              style={{background: "rgba(166, 238, 255, 0.32)", borderRadius: "5px", padding: "8px 0rem 8px 15px", margin: props.showPriceTotalProduct ?"0.5rem 0px 1.5rem":"0 0 20px", display: !props.hideDetail ? "flex":"none", justifyContent: "space-between", width: "100%"}}>
              
              <div
                id="CardSettingPackageUX-div-102"
                style={{fontWeight: "bold", color: "#0072BC"}}>
                {props.languageUX === "en" ? "Price of all products in the package (baht)" : "ราคาของสินค้าทั้งหมดของแพ็กเกจ  (บาท)"}
              </div>
              <div
                id="CardSettingPackageUX-div-130"
                style={{width: "150px", display: "flex", justifyContent: "center"}}>
                
                <div
                  id="CardSettingPackageUX-div-132"
                  style={{color: "#5A5A5A"}}>
                  {props.priceTotal || ""}
                </div>
              </div>
            </div>
          </div>
          <div
            id="CardSettingPackageUX-div-440"
            style={{ padding: "0 40px", ...( props.activePackage !== 1 && { display: "none" } )  }}>
            {props.settingPackageDisplay}
          </div>
        </div>
        <div
          className="ui form"
          id="CardSettingPackageUX-div-103"
          style={{display: !props.hideDetail ? "flex":"none", alignItems: "center", justifyContent: "flex-end", padding: "0 20px"}}>
          
          <div
            id="CardSettingPackageUX-div-127">
            {props.ButtonSave}
          </div>
          <div
            id="CardSettingPackageUX-div-128"
            style={{display: !props.packageDetail?.id ? "none": ""}}>
            {props.ButtonActive}
          </div>
          <Button
            color="purple"
            id="CardSettingPackageUX-Button-107"
            onClick={props.onClickDuplicate}
            style={{display: !props.packageDetail?.id ? "none": ""}}>
            {props.languageUX === "en" ? "DUPLICATE" : "ทำซ้ำ"}
          </Button>
          <Button
            color="red"
            id="CardSettingPackageUX-Button-167"
            onClick={props.onClickCancel}>
            {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
          </Button>
        </div>
      </div>
    )
}


export default CardSettingPackageUX

export const screenPropsDefault = {"current":null,"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Fri Oct 09 2026 11:49:08 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideTitle?\"none\":\"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"15px 10px\", backgroundColor: props.showPackageCategory?\"white\":\"#A5D9FF\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showPackageCategory?\"ตั้งค่าสำหรับเปิดขาย Package\":\"การตั้งค่ารายละเอียดแพ็กเกจ\"",
          "valueEN": "Package details settings"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: 0}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SubSearchPackage"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-4"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "`ui form ${props.isActive  ? \"--override-disabled\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.hideDetail ? \"\": \"none\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.hideDetail ? \"flex\":\"none\", alignItems: \"center\", justifyContent: \"flex-end\", padding: \"0 20px\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Button",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "ทำซ้ำ",
          "valueEN": "DUPLICATE"
        },
        "color": {
          "type": "value",
          "value": "purple"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Button-107"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDuplicate"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.packageDetail?.id ? \"none\": \"\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-127"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonActive"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.packageDetail?.id ? \"none\": \"\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-164"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0 20px\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-165"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", borderBottom: \"1px solid rgba(34,36,38,.15)\", padding: \"0px 0px 0.55rem 0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "code",
          "value": "props.packageDetail?.id?`${props.packageDetail?.code} : ${props.packageDetail?.name}`:props.showPackageCategory?\"สร้างรายการ Paclage ใหม่\":\"เพิ่มรายการใหม่\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-166"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Button",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Button-167"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCancel"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 237,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-237"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0 40px\", ...( props.activePackage !== 0 && { display: \"none\" } )  }"
        }
      },
      "seq": 439,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 238,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "FormField",
      "parent": 238,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": null,
      "id": 240,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "label",
      "parent": 240,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส",
          "valueEN": "Code"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-14"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "label",
      "parent": 240,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสแพ็กเกจ",
          "valueEN": "Package code"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-15"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "label",
      "parent": 240,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-168"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 244,
      "name": "FormField",
      "parent": 238,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.code ? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 245,
      "name": "Input",
      "parent": 244,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Code"
        },
        "name": {
          "type": "value",
          "value": "code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.code || \"\""
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "FormField",
      "parent": 238,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-184"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 247,
      "name": "FormField",
      "parent": 238,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-185"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 248,
      "name": "Label",
      "parent": 247,
      "props": {
        "children": {
          "type": "code",
          "value": "props.labelActive?.text"
        },
        "color": {
          "type": "code",
          "value": "props.labelActive?.color"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Label-186"
        },
        "style": {
          "type": "code",
          "value": "{display: props.labelActive?.text?\"\":\"none\", width: \"100px\", textAlign: \"center\"}"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 249,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 250,
      "name": "FormField",
      "parent": 249,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 250,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "label",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อแพ็คเกจ",
          "valueEN": "Package name"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-21"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "label",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อแพ็กเกจ",
          "valueEN": "Package name"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-22"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "label",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-169"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 255,
      "name": "FormField",
      "parent": 249,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.name ? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 256,
      "name": "Input",
      "parent": 255,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-PackageName"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.name|| \"\""
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-202"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 258,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-203"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-205"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "label",
      "parent": 259,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อแพ็คเกจ",
          "valueEN": "Package name"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-206"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "label",
      "parent": 259,
      "props": {
        "children": {
          "type": "value",
          "value": "(EN)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-207"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "label",
      "parent": 259,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-208"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 263,
      "name": "FormField",
      "parent": 257,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.name ? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-204"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 264,
      "name": "Input",
      "parent": 263,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Input-209"
        },
        "name": {
          "type": "value",
          "value": "name_en"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.name_en|| \"\""
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 265,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-23"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 266,
      "name": "FormField",
      "parent": 265,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 266,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\", marginTop: \"0.75rem\"}"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "label",
      "parent": 267,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทแพ็คเกจ",
          "valueEN": "Package type"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 269,
      "name": "label",
      "parent": 267,
      "props": {
        "children": {
          "type": "value",
          "value": "ชนิดแพ็กเกจ",
          "valueEN": "Package Type"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-33"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": null,
      "id": 270,
      "name": "label",
      "parent": 267,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-170"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 271,
      "name": "FormField",
      "parent": 265,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.package_type ? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": null,
      "id": 272,
      "name": "div",
      "parent": 271,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  alignItems: \"baseline\",}"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 273,
      "name": "Dropdown",
      "parent": 272,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-PackageType"
        },
        "name": {
          "type": "value",
          "value": "package_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.package_type || \"\""
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": null,
      "id": 274,
      "name": "div",
      "parent": 272,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\", display: \"flex\", margin: \"auto -7rem auto 1rem\",cursor: \"pointer\", pointerEvents: props.isActive? \"none\": \"\"}"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 275,
      "name": "Icon",
      "parent": 274,
      "props": {
        "className": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Icon-41"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "plus"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onOpenAdmin?.(\"PACKAGE_TYPE\")"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 276,
      "name": "div",
      "parent": 274,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PackageRefreshIcon"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 277,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 278,
      "name": "FormField",
      "parent": 277,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": null,
      "id": 279,
      "name": "div",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": null,
      "id": 280,
      "name": "label",
      "parent": 279,
      "props": {
        "children": {
          "type": "value",
          "value": "เพศ:",
          "valueEN": "Gender:"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-36"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 281,
      "name": "FormField",
      "parent": 277,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.gender ? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 282,
      "name": "Dropdown",
      "parent": 281,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "defaultValue": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-Gender"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.genderOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.gender || \"\""
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 283,
      "name": "FormField",
      "parent": 277,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-233"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": null,
      "id": 284,
      "name": "div",
      "parent": 283,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-235"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 285,
      "name": "Checkbox",
      "parent": 284,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.packageDetail?.require_age_verification"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Checkbox-236"
        },
        "label": {
          "type": "value",
          "value": "Require Age Verification"
        },
        "name": {
          "type": "value",
          "value": "require_age_verification"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 286,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 287,
      "name": "FormField",
      "parent": 286,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 287,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "label",
      "parent": 288,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-34"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "label",
      "parent": 288,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-35"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": null,
      "id": 291,
      "name": "label",
      "parent": 288,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-171"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 292,
      "name": "FormField",
      "parent": 286,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.package_service_type ? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.75em\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 293,
      "name": "div",
      "parent": 292,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  alignItems: \"baseline\",width: \"100%\"}"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 294,
      "name": "Dropdown",
      "parent": 293,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-ServiceType"
        },
        "name": {
          "type": "value",
          "value": "package_service_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.serviceTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.package_service_type || \"\""
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": null,
      "id": 295,
      "name": "div",
      "parent": 293,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\", display: \"flex\", margin: \"auto -7rem auto 1rem\",cursor: \"pointer\", pointerEvents: props.isActive? \"none\": \"\"}"
        }
      },
      "seq": 295,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 296,
      "name": "Icon",
      "parent": 295,
      "props": {
        "className": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Icon-48"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "plus"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onOpenAdmin?.(\"SERVICE_TYPE\")"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": null,
      "id": 297,
      "name": "div",
      "parent": 295,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ServiceRefreshIcon"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 298,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 299,
      "name": "FormField",
      "parent": 298,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": null,
      "id": 300,
      "name": "div",
      "parent": 299,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": null,
      "id": 301,
      "name": "label",
      "parent": 300,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุเริ่มต้น",
          "valueEN": "Age start"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-55"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "label",
      "parent": 300,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ (ปี)",
          "valueEN": "Age (years)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-56"
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": null,
      "id": 303,
      "name": "label",
      "parent": 300,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-172"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 303,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 304,
      "name": "FormField",
      "parent": 298,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 304,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 305,
      "name": "Input",
      "parent": 304,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-AgeStart"
        },
        "name": {
          "type": "value",
          "value": "age_limits_year_start"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.age_limits_year_start ?? \"\""
        }
      },
      "seq": 305,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 306,
      "name": "FormField",
      "parent": 298,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 306,
      "void": false
    },
    {
      "from": null,
      "id": 307,
      "name": "div",
      "parent": 306,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\", width: \"100%\"}"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": null,
      "id": 308,
      "name": "label",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": "สิ้นสุดอายุ",
          "valueEN": "Age end"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-61"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"5px\"}"
        }
      },
      "seq": 308,
      "void": false
    },
    {
      "from": null,
      "id": 309,
      "name": "label",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ (ปี)",
          "valueEN": "Age (years)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-62"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 310,
      "name": "FormField",
      "parent": 298,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 311,
      "name": "Input",
      "parent": 310,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-AgeEnd"
        },
        "name": {
          "type": "value",
          "value": "age_limits_year_end"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.age_limits_year_end ?? \"\""
        }
      },
      "seq": 311,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 312,
      "name": "FormField",
      "parent": 298,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-137"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showAgeError ? \"\": \"none\"}"
        }
      },
      "seq": 312,
      "void": false
    },
    {
      "from": null,
      "id": 313,
      "name": "label",
      "parent": 312,
      "props": {
        "children": {
          "type": "value",
          "value": "Age end ต้องไม่น้อยกว่า Age start",
          "valueEN": "Age end must not be less than Age start"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-138"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", fontWeight: \"normal\"}"
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 314,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-64"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 314,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 315,
      "name": "FormField",
      "parent": 314,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": null,
      "id": 316,
      "name": "div",
      "parent": 315,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 316,
      "void": false
    },
    {
      "from": null,
      "id": 317,
      "name": "label",
      "parent": 316,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มต้น",
          "valueEN": "Start date"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-71"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",}"
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": null,
      "id": 318,
      "name": "label",
      "parent": 316,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-173"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 318,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 319,
      "name": "FormField",
      "parent": 314,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.start_date? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 319,
      "void": false
    },
    {
      "from": null,
      "id": 320,
      "name": "div",
      "parent": 319,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDate"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 320,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 321,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-73"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 321,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 322,
      "name": "FormField",
      "parent": 321,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-74"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 322,
      "void": false
    },
    {
      "from": null,
      "id": 323,
      "name": "div",
      "parent": 322,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": null,
      "id": 324,
      "name": "label",
      "parent": 323,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สิ้นสุด",
          "valueEN": "End date"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-77"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": null,
      "id": 325,
      "name": "label",
      "parent": 323,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-174"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 326,
      "name": "FormField",
      "parent": 321,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.end_date? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-75"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 326,
      "void": false
    },
    {
      "from": null,
      "id": 327,
      "name": "div",
      "parent": 326,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndDate"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 328,
      "name": "FormField",
      "parent": 321,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-79"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": null,
      "id": 329,
      "name": "div",
      "parent": 328,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", alignItems: \"center\", width: \"100%\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 329,
      "void": false
    },
    {
      "from": null,
      "id": 330,
      "name": "label",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "ใช้งานอยู่",
          "valueEN": "IsActive"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-81"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"1rem\"}"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 331,
      "name": "Checkbox",
      "parent": 329,
      "props": {
        "checked": {
          "type": "code",
          "value": "!!props.packageDetail?.active"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Checkbox-82"
        },
        "name": {
          "type": "value",
          "value": "active"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{transform: \"scale(1.2)\"}"
        }
      },
      "seq": 331,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 332,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 332,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 333,
      "name": "FormField",
      "parent": 332,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 333,
      "void": false
    },
    {
      "from": null,
      "id": 334,
      "name": "div",
      "parent": 333,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 334,
      "void": false
    },
    {
      "from": null,
      "id": 335,
      "name": "div",
      "parent": 334,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginRight: \"5px\"}"
        }
      },
      "seq": 335,
      "void": false
    },
    {
      "from": null,
      "id": 336,
      "name": "label",
      "parent": 335,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาแพ็คเกจ",
          "valueEN": "Package pricing"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-176"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",}"
        }
      },
      "seq": 336,
      "void": false
    },
    {
      "from": null,
      "id": 337,
      "name": "label",
      "parent": 335,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-177"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 337,
      "void": false
    },
    {
      "from": null,
      "id": 338,
      "name": "div",
      "parent": 334,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-181"
        }
      },
      "seq": 338,
      "void": false
    },
    {
      "from": null,
      "id": 339,
      "name": "label",
      "parent": 338,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาขายของสินค้านี้",
          "valueEN": "Selling price of this product"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-182"
        }
      },
      "seq": 339,
      "void": false
    },
    {
      "from": null,
      "id": 340,
      "name": "label",
      "parent": 338,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-183"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 340,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 341,
      "name": "FormField",
      "parent": 332,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.price_normal? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 341,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 342,
      "name": "Input",
      "parent": 341,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Price-Normal"
        },
        "name": {
          "type": "value",
          "value": "price_normal"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "code",
          "value": "props.isActive?\"\":\"number\""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.price_normal|| \"\""
        }
      },
      "seq": 342,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 343,
      "name": "FormField",
      "parent": 332,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-90"
        }
      },
      "seq": 343,
      "void": false
    },
    {
      "from": null,
      "id": 344,
      "name": "label",
      "parent": 343,
      "props": {
        "children": {
          "type": "value",
          "value": "บาท",
          "valueEN": "baht"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-91"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 344,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 345,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 345,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 346,
      "name": "FormField",
      "parent": 345,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 346,
      "void": false
    },
    {
      "from": null,
      "id": 347,
      "name": "div",
      "parent": 346,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-153"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 347,
      "void": false
    },
    {
      "from": null,
      "id": 348,
      "name": "label",
      "parent": 347,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาแพ็กเกจ (พรีเมียม)",
          "valueEN": "Package pricing (Premium)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-155"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 348,
      "void": false
    },
    {
      "from": null,
      "id": 349,
      "name": "label",
      "parent": 347,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-178"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 349,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 350,
      "name": "FormField",
      "parent": 345,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.price_normal? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 350,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 351,
      "name": "Input",
      "parent": 350,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Price-Premium"
        },
        "name": {
          "type": "value",
          "value": "price_premium"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "code",
          "value": "props.isActive?\"\":\"number\""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.price_premium|| \"\""
        }
      },
      "seq": 351,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 352,
      "name": "FormField",
      "parent": 345,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 352,
      "void": false
    },
    {
      "from": null,
      "id": 353,
      "name": "label",
      "parent": 352,
      "props": {
        "children": {
          "type": "value",
          "value": "บาท",
          "valueEN": "baht"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-151"
        }
      },
      "seq": 353,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 354,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 354,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 355,
      "name": "FormField",
      "parent": 354,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-143"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 355,
      "void": false
    },
    {
      "from": null,
      "id": 356,
      "name": "div",
      "parent": 355,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 356,
      "void": false
    },
    {
      "from": null,
      "id": 357,
      "name": "label",
      "parent": 356,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาแพ็กเกจ (ต่างประเทศ)",
          "valueEN": "Package pricing (Foreign)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-156"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 357,
      "void": false
    },
    {
      "from": null,
      "id": 358,
      "name": "label",
      "parent": 356,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-179"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 358,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 359,
      "name": "FormField",
      "parent": 354,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.price_foreign? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-144"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 359,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 360,
      "name": "Input",
      "parent": 359,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Input-Price-Foreign"
        },
        "name": {
          "type": "value",
          "value": "price_foreign"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "code",
          "value": "props.isActive?\"\":\"number\""
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.price_foreign|| \"\""
        }
      },
      "seq": 360,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 361,
      "name": "FormField",
      "parent": 354,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-145"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 361,
      "void": false
    },
    {
      "from": null,
      "id": 362,
      "name": "label",
      "parent": 361,
      "props": {
        "children": {
          "type": "value",
          "value": "บาท",
          "valueEN": "baht"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-152"
        }
      },
      "seq": 362,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 363,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 363,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 364,
      "name": "FormField",
      "parent": 363,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 364,
      "void": false
    },
    {
      "from": null,
      "id": 365,
      "name": "div",
      "parent": 364,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 365,
      "void": false
    },
    {
      "from": null,
      "id": 366,
      "name": "label",
      "parent": 365,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทแพ็คเกจ",
          "valueEN": "Package type"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-163"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 366,
      "void": false
    },
    {
      "from": null,
      "id": 367,
      "name": "label",
      "parent": 365,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-180"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 367,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 368,
      "name": "FormField",
      "parent": 363,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.usage_limit? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 368,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 369,
      "name": "Dropdown",
      "parent": 368,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isActive || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackage-Dropdown-UsageLimit"
        },
        "name": {
          "type": "value",
          "value": "usage_limit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.usageLimitOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.usage_limit || \"\""
        }
      },
      "seq": 369,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 370,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-190"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageCategory?\"\":\"none\"}"
        }
      },
      "seq": 370,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 371,
      "name": "FormField",
      "parent": 370,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-191"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 371,
      "void": false
    },
    {
      "from": null,
      "id": 372,
      "name": "div",
      "parent": 371,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-193"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 372,
      "void": false
    },
    {
      "from": null,
      "id": 373,
      "name": "label",
      "parent": 372,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab Category"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-195"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 373,
      "void": false
    },
    {
      "from": null,
      "id": 374,
      "name": "label",
      "parent": 372,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-196"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 374,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 375,
      "name": "FormField",
      "parent": 370,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-192"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 375,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 376,
      "name": "Dropdown",
      "parent": 375,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": ""
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Dropdown-194"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "package_categories"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageCategoryOptions ?? []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.package_categories || []"
        }
      },
      "seq": 376,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 377,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-210"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 400,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 378,
      "name": "FormField",
      "parent": 377,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-211"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 378,
      "void": false
    },
    {
      "from": null,
      "id": 379,
      "name": "div",
      "parent": 378,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-218"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 379,
      "void": false
    },
    {
      "from": null,
      "id": 380,
      "name": "div",
      "parent": 379,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-219"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginRight: \"5px\"}"
        }
      },
      "seq": 380,
      "void": false
    },
    {
      "from": null,
      "id": 381,
      "name": "label",
      "parent": 380,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุของแพ็กเกจ"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-222"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",}"
        }
      },
      "seq": 381,
      "void": false
    },
    {
      "from": null,
      "id": 382,
      "name": "label",
      "parent": 380,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-223"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 382,
      "void": false
    },
    {
      "from": null,
      "id": 383,
      "name": "div",
      "parent": 379,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-220"
        }
      },
      "seq": 383,
      "void": false
    },
    {
      "from": null,
      "id": 384,
      "name": "label",
      "parent": 383,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุของแพ็กเกจนับตั้งแต่วันที่ซื้อขาย"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-221"
        }
      },
      "seq": 384,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 385,
      "name": "FormField",
      "parent": 377,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-212"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 385,
      "void": false
    },
    {
      "from": null,
      "id": 386,
      "name": "div",
      "parent": 385,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-224"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 386,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 387,
      "name": "Input",
      "parent": 386,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Input-230"
        },
        "name": {
          "type": "value",
          "value": "lifespan_year"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.lifespan_year|| \"\""
        }
      },
      "seq": 387,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 388,
      "name": "FormField",
      "parent": 377,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-213"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 388,
      "void": false
    },
    {
      "from": null,
      "id": 389,
      "name": "label",
      "parent": 388,
      "props": {
        "children": {
          "type": "value",
          "value": "ปี"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-227"
        }
      },
      "seq": 389,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 390,
      "name": "FormField",
      "parent": 377,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-214"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 390,
      "void": false
    },
    {
      "from": null,
      "id": 391,
      "name": "div",
      "parent": 390,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-225"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 391,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 392,
      "name": "Input",
      "parent": 391,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Input-231"
        },
        "name": {
          "type": "value",
          "value": "lifespan_month"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.lifespan_month|| \"\""
        }
      },
      "seq": 392,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 393,
      "name": "FormField",
      "parent": 377,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-215"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 393,
      "void": false
    },
    {
      "from": null,
      "id": 394,
      "name": "label",
      "parent": 393,
      "props": {
        "children": {
          "type": "value",
          "value": "เดือน"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-228"
        }
      },
      "seq": 394,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 395,
      "name": "FormField",
      "parent": 377,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-216"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 395,
      "void": false
    },
    {
      "from": null,
      "id": 396,
      "name": "div",
      "parent": 395,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-226"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 396,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 397,
      "name": "Input",
      "parent": 396,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Input-232"
        },
        "name": {
          "type": "value",
          "value": "lifespan_day"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.lifespan_day|| \"\""
        }
      },
      "seq": 397,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 398,
      "name": "FormField",
      "parent": 377,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-217"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 398,
      "void": false
    },
    {
      "from": null,
      "id": 399,
      "name": "label",
      "parent": 398,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-229"
        }
      },
      "seq": 399,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 400,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-197"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageCategory?\"\":\"none\"}"
        }
      },
      "seq": 405,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 401,
      "name": "FormField",
      "parent": 400,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-199"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 401,
      "void": false
    },
    {
      "from": null,
      "id": 402,
      "name": "label",
      "parent": 401,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลเพิ่มเติมในการเตรียมตัวตรวจ Package"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-200"
        }
      },
      "seq": 402,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 403,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-198"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageCategory?\"\":\"none\"}"
        }
      },
      "seq": 410,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 404,
      "name": "FormField",
      "parent": 403,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SunEditor"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-201"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 404,
      "void": false
    },
    {
      "from": null,
      "id": 405,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.hideDetail ?props.isNewProduct ? \"none\": \"flex\" : \"none\" , justifyContent: \"flex-end\", margin: \"2rem 20px 1rem\"}"
        }
      },
      "seq": 428,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 406,
      "name": "Button",
      "parent": 405,
      "props": {
        "color": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAddNewProduct || false"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Button-93"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddNewProduct"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#5CD6F2\", color: \"white\", display: \"none\"}"
        }
      },
      "seq": 406,
      "void": false
    },
    {
      "from": null,
      "id": 407,
      "name": "div",
      "parent": 406,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 407,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 408,
      "name": "Icon",
      "parent": 407,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Icon-95"
        },
        "name": {
          "type": "value",
          "value": "plus"
        }
      },
      "seq": 408,
      "void": false
    },
    {
      "from": null,
      "id": 409,
      "name": "label",
      "parent": 407,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม รายการใหม่",
          "valueEN": "Add new item"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-97"
        }
      },
      "seq": 409,
      "void": false
    },
    {
      "from": null,
      "id": 410,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.hideDetail ? props.isNewProduct ? \"\": \"none\":\"none\"}"
        }
      },
      "seq": 429,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 411,
      "name": "FormGroup",
      "parent": 410,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 411,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 412,
      "name": "FormField",
      "parent": 411,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-111"
        }
      },
      "seq": 412,
      "void": false
    },
    {
      "from": null,
      "id": 413,
      "name": "label",
      "parent": 412,
      "props": {
        "children": {
          "type": "code",
          "value": "`ค้นหารายการสินค้าจาก ${props.tabName}`"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-112"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 413,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 414,
      "name": "FormGroup",
      "parent": 410,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 414,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 415,
      "name": "FormField",
      "parent": 414,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 415,
      "void": false
    },
    {
      "from": null,
      "id": 416,
      "name": "label",
      "parent": 415,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสสินค้า",
          "valueEN": "Product Code"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-118"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 416,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 417,
      "name": "FormField",
      "parent": 414,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 417,
      "void": false
    },
    {
      "from": null,
      "id": 418,
      "name": "div",
      "parent": 417,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxPCode"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 418,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 419,
      "name": "FormField",
      "parent": 414,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 419,
      "void": false
    },
    {
      "from": null,
      "id": 420,
      "name": "label",
      "parent": 419,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อสินค้า",
          "valueEN": "Product Name"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-119"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 420,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 421,
      "name": "FormField",
      "parent": 414,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 421,
      "void": false
    },
    {
      "from": null,
      "id": 422,
      "name": "div",
      "parent": 421,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxPName"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 422,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 423,
      "name": "FormField",
      "parent": 414,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-117"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 423,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 424,
      "name": "Button",
      "parent": 423,
      "props": {
        "children": {
          "type": "value",
          "value": "เสร็จสิ้น",
          "valueEN": "finish"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Button-122"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddSuccess"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 424,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 425,
      "name": "FormGroup",
      "parent": 410,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-187"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 425,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 426,
      "name": "FormField",
      "parent": 425,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-188"
        },
        "style": {
          "type": "code",
          "value": "{padding:0, marginTop: \"-0.25rem\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 426,
      "void": false
    },
    {
      "from": null,
      "id": 427,
      "name": "div",
      "parent": 426,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CardProductSearch"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-189"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 427,
      "void": false
    },
    {
      "from": null,
      "id": 428,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TabPans"
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-99"
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.hideDetail ? \"\":\"none\"}"
        }
      },
      "seq": 431,
      "void": false
    },
    {
      "from": null,
      "id": 429,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.hideDetail ? \"\":\"none\"}"
        }
      },
      "seq": 435,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 430,
      "name": "Table",
      "parent": 429,
      "props": {
        "data": {
          "type": "code",
          "value": "props.productItems || []"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ID,การส่งตรวจ,Product code,ชื่อสินค้า (EN),ชื่อสินค้า (TH),QTY,หน่วยสั่ง,Price,Display,Delete"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Table-100"
        },
        "keys": {
          "type": "value",
          "value": "product, lab_type, product_code, product_name_en,product_name,quantity,unit_name,price, is_display,delete"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"275px\", marginTop: \"1rem\"}"
        },
        "widths": {
          "type": "value",
          "value": "120,^70,^90,^150,^150,^70,^70,^80,^50,^50"
        }
      },
      "seq": 430,
      "void": false
    },
    {
      "from": null,
      "id": 431,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-124"
        },
        "style": {
          "type": "code",
          "value": "{ borderRadius: \"5px\", padding: \"8px 0rem 8px 15px\", margin: \"0 0px 0\", display: !props.hideDetail ? props.showPriceTotalProduct? \"flex\":\"none\":\"none\", justifyContent: \"space-between\", width: \"100%\"}"
        }
      },
      "seq": 441,
      "void": false
    },
    {
      "from": null,
      "id": 432,
      "name": "div",
      "parent": 431,
      "props": {
        "children": {
          "type": "code",
          "value": "`ราคาของ ${props.productType || \"\"} ทั้งหมด (บาท)`"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"#0072BC\"}"
        }
      },
      "seq": 432,
      "void": false
    },
    {
      "from": null,
      "id": 433,
      "name": "div",
      "parent": 431,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-129"
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\", display: \"flex\", justifyContent: \"center\"}"
        }
      },
      "seq": 433,
      "void": false
    },
    {
      "from": null,
      "id": 434,
      "name": "div",
      "parent": 433,
      "props": {
        "children": {
          "type": "code",
          "value": "props.priceTotalProduct || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#5A5A5A\"}"
        }
      },
      "seq": 434,
      "void": false
    },
    {
      "from": null,
      "id": 455,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-441"
        },
        "style": {
          "type": "code",
          "value": "{background: \"#FFF5F7\", borderRadius: \"5px\", padding: \"8px 0rem 8px 15px\", margin: \"0 0px 0\", display: !props.hideDetail && props.freeGiftCount > 0 ? \"flex\":\"none\", justifyContent: \"space-between\", width: \"100%\"}"
        }
      },
      "seq": 445,
      "void": false
    },
    {
      "from": null,
      "id": 456,
      "name": "div",
      "parent": 455,
      "props": {
        "children": {
          "type": "code",
          "value": "props.freeGiftLabel || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-442"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"#D6305A\"}"
        }
      },
      "seq": 456,
      "void": false
    },
    {
      "from": null,
      "id": 457,
      "name": "div",
      "parent": 455,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-443"
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\", display: \"flex\", justifyContent: \"center\"}"
        }
      },
      "seq": 457,
      "void": false
    },
    {
      "from": null,
      "id": 458,
      "name": "div",
      "parent": 457,
      "props": {
        "children": {
          "type": "code",
          "value": "props.freeGiftTotal || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-444"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#DB2828\", textDecoration: \"line-through\"}"
        }
      },
      "seq": 458,
      "void": false
    },
    {
      "from": null,
      "id": 435,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{background: \"rgba(166, 238, 255, 0.32)\", borderRadius: \"5px\", padding: \"8px 0rem 8px 15px\", margin: props.showPriceTotalProduct ?\"0.5rem 0px 1.5rem\":\"0 0 20px\", display: !props.hideDetail ? \"flex\":\"none\", justifyContent: \"space-between\", width: \"100%\"}"
        }
      },
      "seq": 448,
      "void": false
    },
    {
      "from": null,
      "id": 436,
      "name": "div",
      "parent": 435,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคาของสินค้าทั้งหมดของแพ็กเกจ  (บาท)",
          "valueEN": "Price of all products in the package (baht)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"#0072BC\"}"
        }
      },
      "seq": 436,
      "void": false
    },
    {
      "from": null,
      "id": 437,
      "name": "div",
      "parent": 435,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\", display: \"flex\", justifyContent: \"center\"}"
        }
      },
      "seq": 437,
      "void": false
    },
    {
      "from": null,
      "id": 438,
      "name": "div",
      "parent": 437,
      "props": {
        "children": {
          "type": "code",
          "value": "props.priceTotal || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#5A5A5A\"}"
        }
      },
      "seq": 438,
      "void": false
    },
    {
      "from": null,
      "id": 439,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TabPackage"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-439"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"1.5em\", ...( !props.showPackageDisplay && { display: \"none\" } ) }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 440,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.settingPackageDisplay"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-440"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0 40px\", ...( props.activePackage !== 1 && { display: \"none\" } )  }"
        }
      },
      "seq": 440,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 441,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-190"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageCategory?\"\":\"none\"}"
        }
      },
      "seq": 377,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 442,
      "name": "FormField",
      "parent": 441,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-191"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 442,
      "void": false
    },
    {
      "from": null,
      "id": 443,
      "name": "div",
      "parent": 442,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-193"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 443,
      "void": false
    },
    {
      "from": null,
      "id": 444,
      "name": "label",
      "parent": 443,
      "props": {
        "children": {
          "type": "value",
          "value": "อาการ/ความกังวล (Health concerns)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-195"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 444,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 446,
      "name": "FormField",
      "parent": 441,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-192"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 446,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 447,
      "name": "Dropdown",
      "parent": 446,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": ""
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Dropdown-194"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "health_concerns"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.healthConcernListOptions ?? []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.packageDetail?.health_concerns || []"
        }
      },
      "seq": 447,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 448,
      "name": "FormGroup",
      "parent": 237,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormGroup-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 403,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 449,
      "name": "FormField",
      "parent": 448,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 449,
      "void": false
    },
    {
      "from": null,
      "id": 450,
      "name": "div",
      "parent": 449,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"230px\"}"
        }
      },
      "seq": 450,
      "void": false
    },
    {
      "from": null,
      "id": 451,
      "name": "label",
      "parent": 450,
      "props": {
        "children": {
          "type": "value",
          "value": "ซื้อได้เฉพาะผ่าน Link Affiliage"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-label-163"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 451,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 453,
      "name": "FormField",
      "parent": 448,
      "props": {
        "className": {
          "type": "code",
          "value": "!!props.showRequiredField?.usage_limit? \"error\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 453,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 454,
      "name": "Checkbox",
      "parent": 453,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.packageDetail?.is_affiliate_exclusive"
        },
        "id": {
          "type": "value",
          "value": "CardSettingPackageUX-Checkbox-454"
        },
        "name": {
          "type": "value",
          "value": "is_affiliate_exclusive"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 454,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 95,
  "isMounted": false,
  "memo": false,
  "name": "CardSettingPackageUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "current": null,
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
